import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useSeo } from "@/lib/useSeo";
import { PageHero } from "@/components/site/PageHero";

const TITLES = {
  "privacy-policy": "Privacy Policy", "terms-of-use": "Terms of Use",
  "disclaimer": "Disclaimer", "payment-cancellation-policy": "Payment & Cancellation Policy",
};

export default function LegalPage({ slug }) {
  const [doc, setDoc] = useState(undefined); // undefined=loading, null=unpublished
  useEffect(() => {
    let ok = true;
    api.get(`/cms/legal/${slug}`).then((r) => ok && setDoc(r.data)).catch(() => ok && setDoc(null));
    return () => { ok = false; };
  }, [slug]);

  const title = doc?.title || TITLES[slug] || "Legal";
  const brandedTitle = doc?.seo_title ? doc.seo_title : `${title} | Maha Sampada`;
  useSeo({ title: brandedTitle, description: doc?.meta_description || "" });

  // Draft/unpublished pages must not be indexed.
  useEffect(() => {
    if (doc === null) {
      const m = document.createElement("meta");
      m.setAttribute("name", "robots"); m.setAttribute("content", "noindex, nofollow");
      document.head.appendChild(m);
      return () => document.head.removeChild(m);
    }
  }, [doc]);

  return (
    <div>
      <PageHero overline="Legal" title={title} image="https://images.unsplash.com/photo-1663079156029-a170af256f67?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000" crumbs={[{ label: title }]} height="h-[40vh]" />
      <section className="mx-auto max-w-3xl px-4 py-16 sm:px-6" data-testid={`legal-page-${slug}`}>
        {doc === undefined && <p className="text-sm text-muted-foreground">Loading…</p>}
        {doc === null && <p className="text-base text-muted-foreground" data-testid="legal-unpublished">This policy is being updated and will be available shortly. Please contact us if you need this information right away.</p>}
        {doc && (
          <>
            {(doc.version_number || doc.effective_date || doc.last_updated_date) && (
              <div className="mb-6 flex flex-wrap gap-x-6 gap-y-1 font-accent text-xs text-muted-foreground">
                {doc.version_number && <span>Version {doc.version_number}</span>}
                {doc.effective_date && <span>Effective: {doc.effective_date}</span>}
                {doc.last_updated_date && <span>Last updated: {doc.last_updated_date}</span>}
              </div>
            )}
            <div className="ms-rich text-base leading-relaxed text-charcoal" data-testid="legal-body" dangerouslySetInnerHTML={{ __html: doc.body || "" }} />
          </>
        )}
      </section>
    </div>
  );
}
